import React, { useState } from "react";
import {
  AccordionSummaryContatiner,
  ButtonContainer,
  Container,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledParagraph,
} from "./styles";
import { LargeHeading, Paragraph } from "../../../../lib/Font/styles";
import DownArrowButton from "../../../base/Buttons/DownArrowButton/DownArrowButton";
import { motion } from "framer-motion";

interface AboutAccordionProps {
  timePeriod: string;
  summaryText: string;
  detailsText: string;
  imagePath: string;
}

const AboutAccordion: React.FC<AboutAccordionProps> = ({
  timePeriod,
  summaryText,
  detailsText,
  imagePath,
}) => {
  
  const [clicked, setClicked] = useState(false);

  const handleAccordionChange = () => {
    setClicked((prev) => !prev);
  };

  return (
    <Container>
      <StyledAccordion
        imagePath={imagePath}
        expanded={clicked}
        onChange={handleAccordionChange}
      >
        <StyledAccordionSummary aria-controls="panel1-content" id="panel1-header">
          <AccordionSummaryContatiner>
            <LargeHeading>{timePeriod}</LargeHeading>
            <StyledParagraph>{summaryText}</StyledParagraph>
            <ButtonContainer>
              <motion.div
                animate={{ rotate: clicked ? 180 : 0 }}
                transition={{ duration: 0.2 }}
              >
                <DownArrowButton onClick={()=>{}} />
              </motion.div>
              <Paragraph>{clicked ? "Weniger erfahren" : "Mehr erfahren"}</Paragraph>
            </ButtonContainer>
          </AccordionSummaryContatiner>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Paragraph>{detailsText}</Paragraph>
        </StyledAccordionDetails>
      </StyledAccordion>
    </Container>
  );
};

export default AboutAccordion;
